// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "video-module--base-text-alt--global--81e76";
export var baseTextGlobal = "video-module--base-text--global--9dd21";
export var blockSpacing100 = "video-module--block-spacing-100--26fd5";
export var blockSpacing50 = "video-module--block-spacing-50--3070a";
export var blockVPadding100 = "video-module--block-v-padding-100--09a41";
export var blockVPadding50 = "video-module--block-v-padding-50--4ba7e";
export var captionTextGlobal = "video-module--caption-text--global--70697";
export var cmsRenderedContentGlobal = "video-module--cms-rendered-content--global--83fa0";
export var defaultHSpacingGlobal = "video-module--default-h-spacing--global--98386";
export var fadeInAnimation = "video-module--fadeInAnimation--adbe1";
export var fadeInOnLoadGlobal = "video-module--fade-in-on-load--global--c3d4e";
export var fullHeightGlobal = "video-module--full-height--global--ce5b0";
export var fullHeightOmittingNavGlobal = "video-module--full-height-omitting-nav--global--e5883";
export var headingTextGlobal = "video-module--heading-text--global--769ac";
export var ingressTextGlobal = "video-module--ingress-text--global--47bcc";
export var linkColorChangeTransitionGlobal = "video-module--link-color-change-transition--global--6ce3a";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "video-module--page-heading-text--global--79545";
export var paragraphTextGlobal = "video-module--paragraph-text--global--a4236";
export var subheadingTextGlobal = "video-module--subheading-text--global--a0546";
export var video = "video-module--video--b98db";
export var videoWrapper = "video-module--videoWrapper--843fa";